import { AnyAppEvent, AppEvent } from "../../appEvent.types";
import { z } from "zod";

const eventName = "open-exponent-conversation" as const;

export const OpenExponentConversationEventDataSchema = z.object({
  structureId: z.string(),
  eventId: z.string(),
});

export type OpenExponentConversationEventData = z.infer<
  typeof OpenExponentConversationEventDataSchema
>;

export type OpenExponentConversationEvent = AppEvent<
  typeof eventName,
  OpenExponentConversationEventData
>;

export const isOpenExponentConversationEvent = (
  event: AnyAppEvent
): event is OpenExponentConversationEvent => event.name === eventName;

export { eventName as openExponentConversation };
